import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";

function Logo() {
  return (
    <Link to="/dashboard">
      <img src={logo} alt="GIGM LOGO" />
    </Link>
  );
}

export default Logo;
